import { carnival,
    christmas,
    climate,
    easter,
    economy,
    elections,
    germany,
    halloween,
    holiday,
    school,
    silvester
} from "./animation";

carnival();
christmas();
climate();
easter();
economy();
elections();
germany();
halloween();
holiday();
school();
silvester();